import { render } from "./IconNotifications.vue?vue&type=template&id=7385fe8c"
import script from "./IconNotifications.vue?vue&type=script&lang=js"
export * from "./IconNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__